(function () {

  const CATALOG_SELECTOR = '[data-proxium-product-catalog]';

  function initProductCatalog(catalog) {

    if (!catalog) return;

    /*
    ==========================================================
    ELEMENTOS
    ==========================================================
    */

    const grid = catalog.querySelector('[data-product-grid]');

    const categoryFilter = catalog.querySelector(
      '[data-product-category-filter]'
    );

    const sortFilter = catalog.querySelector(
      '[data-product-sort]'
    );

    const productCount = catalog.querySelector(
      '[data-product-count]'
    );

    const emptyState = catalog.querySelector(
      '[data-product-empty]'
    );

    if (!grid) return;


    /*
    ==========================================================
    OBTENER PRODUCTOS
    ==========================================================
    */

    function getCards() {

      return Array.from(
        grid.querySelectorAll('[data-product-card]')
      );

    }


    /*
    ==========================================================
    CONVERTIR VALORES
    ==========================================================
    */

    function getPrice(card) {

      const value = parseFloat(
        card.dataset.price || '0'
      );

      return Number.isFinite(value)
        ? value
        : 0;

    }


    function getOriginalOrder(card) {

      const value = parseInt(
        card.dataset.originalOrder || '0',
        10
      );

      return Number.isFinite(value)
        ? value
        : 0;

    }


    function isRecommended(card) {

      return card.dataset.recommended === '1';

    }


    function getTitle(card) {

      return (
        card.dataset.title || ''
      ).trim();

    }


    /*
    ==========================================================
    FILTRAR PRODUCTOS
    ==========================================================
    */

    function filterCards(cards) {

      const selectedCategory =
        categoryFilter
          ? categoryFilter.value
          : 'all';

      return cards.filter(function (card) {

        const productCategory =
          card.dataset.category || '';

        const visible =
          selectedCategory === 'all' ||
          productCategory === selectedCategory;

        card.classList.toggle(
          'is-filtered-out',
          !visible
        );

        return visible;

      });

    }


    /*
    ==========================================================
    ORDENAR PRODUCTOS
    ==========================================================
    */

    function sortCards(cards) {

      const selectedSort =
        sortFilter
          ? sortFilter.value
          : 'recommended';

      return cards.sort(function (a, b) {

        /*
        PRECIO MENOR → MAYOR
        */

        if (selectedSort === 'price-asc') {

          return (
            getPrice(a) -
            getPrice(b)
          ) || (
            getOriginalOrder(a) -
            getOriginalOrder(b)
          );

        }


        /*
        PRECIO MAYOR → MENOR
        */

        if (selectedSort === 'price-desc') {

          return (
            getPrice(b) -
            getPrice(a)
          ) || (
            getOriginalOrder(a) -
            getOriginalOrder(b)
          );

        }


        /*
        NOMBRE A → Z
        */

        if (selectedSort === 'name-asc') {

          return getTitle(a).localeCompare(
            getTitle(b),
            'es',
            {
              sensitivity: 'base'
            }
          );

        }


        /*
        RECOMENDADOS
        */

        return (
          Number(isRecommended(b)) -
          Number(isRecommended(a))
        ) || (
          getOriginalOrder(a) -
          getOriginalOrder(b)
        );

      });

    }


    /*
    ==========================================================
    ACTUALIZAR CATÁLOGO
    ==========================================================
    */

    function updateCatalog() {

      const cards = getCards();

      const visibleCards =
        filterCards(cards);

      const sortedCards =
        sortCards(visibleCards);


      /*
      REORDENAR VISUALMENTE
      */

      sortedCards.forEach(function (card) {

        grid.appendChild(card);

      });


      /*
      CONTADOR
      */

      if (productCount) {

        productCount.textContent =
          visibleCards.length;

      }


      /*
      SIN RESULTADOS
      */

      if (emptyState) {

        emptyState.hidden =
          visibleCards.length !== 0;

      }

    }


    /*
    ==========================================================
    EVENTOS
    ==========================================================
    */

    if (categoryFilter) {

      categoryFilter.addEventListener(
        'change',
        updateCatalog
      );

    }


    if (sortFilter) {

      sortFilter.addEventListener(
        'change',
        updateCatalog
      );

    }


    /*
    ==========================================================
    ESTADO INICIAL
    ==========================================================
    */

    updateCatalog();

  }


  /*
  ============================================================
  INICIAR CATÁLOGOS
  ============================================================
  */

  function initAllCatalogs(scope) {

    const root = scope || document;

    /*
    Si el propio scope es el catálogo
    */

    if (
      root.matches &&
      root.matches(CATALOG_SELECTOR)
    ) {

      initProductCatalog(root);

    }


    /*
    Buscar catálogos dentro del scope
    */

    if (root.querySelectorAll) {

      root
        .querySelectorAll(CATALOG_SELECTOR)
        .forEach(function (catalog) {

          initProductCatalog(catalog);

        });

    }

  }


  /*
  ============================================================
  CARGA NORMAL DE LA WEB
  ============================================================
  */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initAllCatalogs(document);

      }
    );

  } else {

    initAllCatalogs(document);

  }


  /*
  ============================================================
  EDITOR VISUAL DE SHOPIFY
  ============================================================
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAllCatalogs(event.target);

    }
  );

})();